import type { TenantAnalyticsDeliveryResult } from '@kit/analytics/tenant';

/**
 * A session marker is final when every configured adapter either delivered or
 * was deliberately suppressed by the visitor's consent choice.
 */
export function isTenantAnalyticsDeliveryComplete(
  results: readonly TenantAnalyticsDeliveryResult[],
) {
  return (
    results.length > 0 &&
    results.every(
      (result) =>
        result.status === 'delivered' ||
        (result.status === 'skipped' && result.reason === 'consent_denied'),
    )
  );
}
